import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { StateChangeReasonKey } from "@app2/clients/types/alert-typedefs";

interface DialogData {
    currentState: string;
    currentTriggerName: string;
}

type DismissalChoice = {
    id: string;
    value: string;
    localizeKey: string;
};

@Component({
    selector: "dismiss-form-modal",
    template: `
        <span mat-dialog-title>{{ "DISMISSAL_MODAL_TITLE" | localize }}</span>
        <mat-dialog-content>
            <article>
                <p id="dismissal-header" [innerHTML]="'DISMISSAL_MODAL_HEADER' | localize:this.currentTriggerName"></p>
                <form #f="ngForm" class="nice-form" test-class="dismiss-form">
                    <h1 class="sub-header">{{ "DISMISSAL_REASON" | localize }}</h1>
                    <section>
                        <div *ngFor="let choice of dismissalChoices">
                            <input type="radio" id="{{choice.id}}" name="dismissal-reason" value="{{choice.value}}"
                                   required
                                   [(ngModel)]="dismissalReasonKey">
                            <label for="{{choice.id}}">{{ choice.localizeKey | localize }}</label>
                        </div>
                    </section>
                    <h1 class="sub-header">{{ "ADDITIONAL_DETAILS" | localize }}</h1>
                    <section>
                    <textarea id="additional-detail" name="additional-detail" [(ngModel)]="dismissalDetail"
                              [required]="dismissalReasonKey === 'OTHER'"
                              rows="5"></textarea>
                    </section>
                </form>
            </article>
        </mat-dialog-content>
        <mat-dialog-actions>
            <modal-buttons [canSave]="f.valid"
                           (onCancel)="onCancel()"
                           (onSave)="onSave()">
            </modal-buttons>
        </mat-dialog-actions>
    `,
})
export class DismissFormModalComponent {
    dismissalReasonKey: string = "NO_THREAT";
    dismissalDetail: string;
    currentState: string;
    currentTriggerName: string;

    dismissalChoices: DismissalChoice[] = [
        { id: "no-threat", value: StateChangeReasonKey.noThreat, localizeKey: "DISMISSAL_NO_THREAT" },
        { id: "adjust-trigger", value: StateChangeReasonKey.adjustTrigger, localizeKey: "DISMISSAL_ADJUST_TRIGGER" },
        { id: "duplicate", value: StateChangeReasonKey.duplicate, localizeKey: "DISMISSAL_DUPLICATE" },
        { id: "other", value: StateChangeReasonKey.other, localizeKey: "DISMISSAL_OTHER" },
    ];


    constructor(private dialogRef: MatDialogRef<DismissFormModalComponent>,
                @Inject(MAT_DIALOG_DATA) public data: DialogData) {
        this.currentState = data.currentState;
        this.currentTriggerName = data.currentTriggerName;
    }

    onCancel(): void {
        this.dialogRef.close();
    }

    onSave(): void {
        this.dialogRef.close({
            oldState: this.currentState,
            newState: "DISMISSED",
            reasonKey: this.dismissalReasonKey,
            detail: this.dismissalDetail || undefined,
        });
    }
}
